import classNames from 'classnames';

import styles from './SearchResultGrid.module.css';

export interface SearchResultGridProps {
  children: React.ReactNode;
  singleColumn?: boolean;
  className?: string;
}

export const SearchResultGrid = ({
  children,
  singleColumn = false,
  className = undefined,
}: SearchResultGridProps) => {
  return (
    <div
      className={classNames(
        styles.root,
        className,
        singleColumn ? styles.singleColumn : styles.responsive,
      )}
    >
      {children}
    </div>
  );
};
